import type { ReactNode } from "react";

export function Panel({
  title,
  subtitle,
  right,
  children,
}: {
  title: string;
  subtitle?: string;
  right?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section
      className="rounded-xl border"
      style={{ borderColor: "var(--nl2s-border)", background: "var(--nl2s-surface)" }}
    >
      <header
        className="flex items-center gap-3 border-b px-4 py-2.5"
        style={{ borderColor: "var(--nl2s-border)" }}
      >
        <div className="min-w-0">
          <h2 className="text-sm font-semibold" style={{ color: "var(--nl2s-text)" }}>
            {title}
          </h2>
          {subtitle ? (
            <p className="text-xs" style={{ color: "var(--nl2s-text-muted)" }}>
              {subtitle}
            </p>
          ) : null}
        </div>
        {right ? <div className="ml-auto">{right}</div> : null}
      </header>
      <div className="p-4">{children}</div>
    </section>
  );
}
